"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _LinkBookings = _interopRequireDefault(require("../screens/LinkBookings"));
var validators = _interopRequireWildcard(require("../../../../services/input/validators"));
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var _checkEmail = _interopRequireDefault(require("../../mutations/checkEmail"));
var _context = require("../../../../services/brand/context");
var _context2 = require("../../../../services/log/context");
var _events = require("../../consts/events");
var _otpLogin = _interopRequireDefault(require("../../mutations/otpLogin"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LinkBookingsScreen = ({
  onChangeScreen,
  email,
  onEmailChange,
  onOtpTransactionIdChange
}) => {
  const intl = (0, _reactIntl.useIntl)();
  const [error, setError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [emailError, setEmailError] = React.useState(null);
  const [validateEmail, setValidateEmail] = React.useState(false);
  const {
    id: brandId
  } = (0, _context.useBrand)();
  const {
    log
  } = (0, _context2.useLog)();
  function validateInput() {
    const error = email ? validators.email(email) : _errors.default.requiredField;
    setValidateEmail(true);
    return Boolean(error);
  }
  function onEmailBlur() {
    setValidateEmail(true);
  }
  React.useEffect(() => {
    log(_events.APPLE_LINKING_INITIALIZED, {});
  }, [log]);
  React.useEffect(() => {
    if (validateEmail) {
      setEmailError(email ? validators.email(email) : _errors.default.requiredField);
    }
  }, [validateEmail, email]);
  function onSkipClick() {
    onChangeScreen("oldBookings");
  }
  function onContinueClick(e) {
    e.preventDefault();
    if (validateInput()) {
      return;
    }
    setIsLoading(true);
    setError(null);
    (0, _checkEmail.default)({
      email,
      brandId
    }).then(result => {
      if (!result) {
        log(_events.LOGIN_STEP_FAILED, {
          operation: "signInWithAppleCheckEmail"
        });
        setError(_errors.default.general);
        return;
      }
      if (result.hasKiwiAccount) {
        (0, _otpLogin.default)({
          email
        }).then(res => {
          if ("transactionId" in res) {
            onOtpTransactionIdChange(res.transactionId);
            onChangeScreen("verifyEmail");
            return;
          }
          log(_events.OTP_LOGIN_FAILED, {
            operation: "otpLogin",
            error: res.error
          });
          setError(_errors.default.general);
        }).catch(err => {
          setIsLoading(false);
          setError(_errors.default.general);
          log(_events.CRITICAL_LOGIN_ERROR, {
            error: String(err),
            operation: "otpLogin"
          });
        });
        return;
      }
      onChangeScreen("noAccountFound");
    }).catch(err => {
      log(_events.CRITICAL_LOGIN_ERROR, {
        error: String(err),
        operation: "checkEmail"
      });
      setIsLoading(false);
      setError(_errors.default.general);
    });
  }
  function onBackClick() {
    onChangeScreen("intro");
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinkBookings.default, {
    onBackClick: onBackClick,
    onEmailChange: onEmailChange,
    onEmailBlur: onEmailBlur,
    email: email,
    emailError: emailError,
    onSkipClick: onSkipClick,
    onContinueClick: onContinueClick,
    isLoading: isLoading,
    error: error != null && intl.formatMessage(error)
  });
};
var _default = LinkBookingsScreen;
exports.default = _default;